// GenieTrigger — the "Ask Risa" pill that opens the R.I.S.A assistant. Lives in
// the page head on every screen. Generic (the panel it opens is wired by the
// shell). Shows the ⌘G shortcut hint. From the prototype's GenieTrigger.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cx } from '../../../utils/cx';
import { SparkleIcon } from '../../icons/Icons';
import './genie-trigger.css';

export function GenieTrigger({ onClick, open = false, label, kbd = '⌘G', className }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={cx('genie-trigger', open && 'is-open', className)}
      onClick={onClick}
      aria-expanded={open}
    >
      <span className="genie-trigger__sparkle">
        <SparkleIcon />
      </span>
      {label ?? t('reusable.genieTrigger.ask')}
      {kbd && <span className="genie-trigger__kbd">{kbd}</span>}
    </button>
  );
}

GenieTrigger.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool,
  label: PropTypes.node,
  kbd: PropTypes.node,
  className: PropTypes.string,
};

export default GenieTrigger;
